import { render, staticRenderFns } from "./SettingsClientModal.vue?vue&type=template&id=6802f675&scoped=true&"
import script from "./SettingsClientModal.vue?vue&type=script&lang=js&"
export * from "./SettingsClientModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsClientModal.vue?vue&type=style&index=0&id=6802f675&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6802f675",
  null
  
)

export default component.exports